import { record } from 'fp-ts';
import type { Predicate, Refinement } from 'fp-ts/lib/function';

/**
 * record.filter with key-preserving signatures
 *
 * This is unfortunately not included in fp-ts, filed an issue for it:
 * https://github.com/gcanti/fp-ts/issues/1620
 */
export const recordFilterWithKeyType: {
  <K extends string, A, B extends A>(
    refinement: Refinement<A, B>,
  ): (fa: Record<K, A>) => Record<K, B>;
  <K extends string, A>(
    predicate: Predicate<A>,
  ): (fa: Record<K, A>) => Record<K, A>;
} = record.filter;
